import * as THREE from 'three';
import { gsap } from 'gsap';
import { GLTFLoader } from 'three/addons/loaders/GLTFLoader';
import { AmbientLight } from 'three';
import { element } from 'three/webgpu';

export default class Experience {
  constructor() {
    this.sizes = {
      width: window.innerWidth,
      height: window.innerHeight,
    };

    this.canvas = document.querySelector('.webgl');
    this.gltfLoader = new GLTFLoader();
    this.scene = new THREE.Scene();
    this.clock = new THREE.Clock();

    //Breakpoint tablette
    if (window.matchMedia('(min-width: 800px)').matches) {
      //Pour bouger la tête
      this.mouseX;
      this.mouseY;

      this.targetX;
      this.targetY;

      this.windowHalfX = window.innerWidth / 2;
      this.windowHalfY = window.innerHeight / 2;
    }
    this.init();
  }

  init() {
    window.addEventListener('resize', this.resize.bind(this));
    //console.log('3D');
    const observer = new IntersectionObserver(this.observe.bind(this), {
      rootMargin: '0px 0px',
    });
    this.createCamera();
    this.createLights();
    this.createObjects();
    this.createRenderer();
    this.animate();

    document.addEventListener('mousemove', this.onDocumentMouseMove.bind(this));

    const experiences = document.querySelectorAll('.js-experience');
    for (let i = 0; i < experiences.length; i++) {
      const element = experiences[i];
      observer.observe(element);
    }
  }
  onDocumentMouseMove(event) {
    this.mouseX = event.clientX - this.windowHalfX;
    this.mouseY = event.clientY - this.windowHalfY;
  }
  createLights() {
    const ambLight = new THREE.AmbientLight('#ffffff', 0.8);
    this.scene.add(ambLight);

    const dirLight = new THREE.DirectionalLight('#ffffff', 4);
    dirLight.position.set(1, 2, 5);
    dirLight.castShadow = true;
    dirLight.shadow.camera.far = 10;
    dirLight.shadow.normalBias = 0.027;
    dirLight.shadow.bias = -0.004;
    this.scene.add(dirLight);
  }

  createCamera() {
    this.camera = new THREE.PerspectiveCamera(
      45,
      this.sizes.width / this.sizes.height
    );
    this.camera.position.z = 8;
    this.scene.add(this.camera);
  }

  createRenderer() {
    this.renderer = new THREE.WebGLRenderer({
      canvas: this.canvas,
      alpha: true,
    });
    this.renderer.setSize(this.sizes.width, this.sizes.height);
    this.renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
    this.renderer.shadowMap.enabled = true;
    this.renderer.shadowMap.type = THREE.PCFSoftShadowMap;
    this.renderer.render(this.scene, this.camera);
  }

  createObjects() {
    // Objet importé
    this.gltfLoader.load('assets/models/t/tete2.gltf', (gltf) => {
      this.model = gltf.scene;
      this.model.scale.set(3, 3, 3);
      this.model.position.y = -1;
      this.model.rotation.x = 0;
      this.model.rotation.y = 0.2;
      // Ombres
      this.model.traverse((child) => {
        if (child.isMesh && child.material.isMeshStandardMaterial) {
          child.castShadow = true;
          child.receiveShadow = true;
        }
      });

      this.scene.add(this.model);
    });
  }

  resize() {
    // Update sizes
    this.sizes.width = window.innerWidth;
    this.sizes.height = window.innerHeight;

    // Update camera
    this.camera.aspect = this.sizes.width / this.sizes.height;
    this.camera.updateProjectionMatrix();

    // Update renderer
    this.renderer.setSize(this.sizes.width, this.sizes.height);
    this.renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));

    this.renderer.render(this.scene, this.camera);
  }

  animate() {
    this.renderer.render(this.scene, this.camera);
    const elapsedTime = this.clock.getElapsedTime();

    //Breakpoint tablette
    if (window.matchMedia('(min-width: 800px)').matches) {
      this.targetX = this.mouseX * 0.001;
      this.targetY = this.mouseY * 0.001;

      if (this.model) {
        //Update objects - increase number to create automated animation
        this.model.rotation.x = 0 * elapsedTime;
        this.model.rotation.y = 0 * elapsedTime;

        this.model.rotation.x += 2 * (this.targetY - this.model.rotation.x);
        this.model.rotation.y += 1.5 * (this.targetX - this.model.rotation.y);

        this.model.rotation.set(
          this.targetY,
          this.targetX,
          this.model.rotation.z
        );
      }
    } else {
      if (this.model) {
        //Update objects - increase number to create automated animation
        this.model.rotation.y = 0.2 * elapsedTime;
      }
    }

    window.requestAnimationFrame(this.animate.bind(this));
  }

  observe(entries) {
    for (let i = 0; i < entries.length; i++) {
      const entry = entries[i];
      const target = entry.target;

      //on vérifie si ça intersecte et si le model existe
      if (entry.isIntersecting && this.model) {
        //console.log(target);
        //const posX = (Math.random() - 0.5) * 4;
        gsap.to(this.model.position, {
          duration: 1,
          ease: 'power2.inOut',
          //x: posX,
          x: target.dataset.p,
        });
        gsap.to(this.model.rotation, {
          duration: 1,
          ease: 'power2.inOut',
          x: target.dataset.rX,
          y: target.dataset.rY,
          z: target.dataset.rZ,
        });

        // La ligne suivant est égale au if précédent. C'est un if sur une ligne
        const cameraZ = 'cZ' in target.dataset ? target.dataset.cZ : 8;

        gsap.to(this.camera.position, {
          duration: 1,
          ease: 'power2.inOut',
          z: cameraZ,
        });
      }
    }
  }
}
new Experience();
